function translateKey(key, literals) {
  return literals ? literals[key] : '';
}

export { translateKey };
